import { render, staticRenderFns } from "./ShowItemModal.vue?vue&type=template&id=83427e94"
import script from "./ShowItemModal.vue?vue&type=script&lang=js"
export * from "./ShowItemModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports